import React from 'react';
import { Divider, Typography } from 'antd';
import {
  EmbeddedEstimatesTable,
  EmbeddedInvoicesTable,
} from '../../finance/EmbeddedFinanceDocs';

const { Title } = Typography;

/**
 * تب صورتحساب معامله — پیش‌فاکتورها و فاکتورهای مرتبط
 */
const BillingTab = ({
  dealId,
  clientId,
  data,
  onRefresh,
  navigateWithTrail,
}) => {
  const estimates = Array.isArray(data?.estimates) ? data.estimates : [];
  const invoices = Array.isArray(data?.invoices) ? data.invoices : [];

  return (
    <div style={{ fontFamily: 'CustomFont' }} className="space-y-6">
      <section>
        <Title level={5} style={{ fontFamily: 'CustomFont', marginBottom: 12 }}>
          پیش‌فاکتورها
        </Title>
        <EmbeddedEstimatesTable
          estimates={estimates}
          showDealColumn={false}
          showProjectColumn
          clientId={clientId}
          dealId={dealId}
          onChanged={onRefresh}
          createEnabled
          navigateWithTrail={navigateWithTrail}
        />
      </section>

      <Divider className="my-2" />

      <section>
        <Title level={5} style={{ fontFamily: 'CustomFont', marginBottom: 12 }}>
          فاکتورها
        </Title>
        <EmbeddedInvoicesTable
          invoices={invoices}
          showDealColumn={false}
          showProjectColumn
          clientId={clientId}
          dealId={dealId}
          onChanged={onRefresh}
          createEnabled
          navigateWithTrail={navigateWithTrail}
        />
      </section>
    </div>
  );
};

export default BillingTab;
